var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "ICodeIndex i18n",
      class: _vm.gameMode == _vm.CppOldMode ? "backgroundColor" : ""
    },
    [
      _c("div", { staticClass: "header", attrs: { id: "header" } }, [
        _c("i", { staticClass: "IcodeIcon" }),
        _vm._v(" "),
        _vm.deviceType == "pc"
          ? _c("div", { staticClass: "bounced" }, [
              _vm.$i18n.locale == "zh"
                ? _c(
                    "a",
                    {
                      attrs: {
                        href:
                          "https://mp.weixin.qq.com/s/UMo_85nFTiBzKEv1etC2IQ",
                        target: "_blank"
                      }
                    },
                    [_vm._v("\n          ICode中国区决赛\n        ")]
                  )
                : _vm._e()
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "header-btns clearfix" }, [
          _c(
            "div",
            {
              staticClass: "latency-indicator",
              attrs: { title: _vm.latencyTooltip },
              on: { click: _vm.checkLatency }
            },
            [
              _c("span", {
                staticClass: "latency-dot",
                style: { backgroundColor: _vm.latencyColor }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "changeLangBtn",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  _vm.moreLang()
                }
              }
            },
            [
              _c("img", {
                staticClass: "naviIcon",
                attrs: { src: require("@/assets/images/language.png") }
              }),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  "\n            " + _vm._s(_vm.$t("language")) + "\n          "
                )
              ]),
              _vm._v(" "),
              _c(
                "ul",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.changeLangBox,
                      expression: "changeLangBox"
                    }
                  ],
                  staticClass: "chooseLangUl"
                },
                _vm._l(_vm.langList, function(item, index) {
                  return _c(
                    "li",
                    {
                      key: index,
                      staticClass: "chooseLangUlli",
                      on: {
                        click: function($event) {
                          _vm.setLanguage(item.id)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(item.name) +
                          "\n            "
                      )
                    ]
                  )
                })
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "modeSwitchBtn",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  _vm.modeSwitch()
                }
              }
            },
            [
              _vm.gameMode == _vm.BlocklyMode
                ? _c("img", {
                    staticClass: "naviIcon",
                    attrs: { src: require("@/assets/images/blocklyIcon.png") }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.gameMode == _vm.PythonMode
                ? _c("img", {
                    staticClass: "naviIcon",
                    attrs: { src: require("@/assets/images/pythonIcon.png") }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.gameMode == _vm.CppMode
                ? _c("img", {
                    staticClass: "naviIcon",
                    attrs: { src: require("@/assets/images/cppIcon.png") }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.gameMode == _vm.BlocklyMode
                ? _c("span", [_vm._v(_vm._s(_vm.$t("Blockly")))])
                : _vm._e(),
              _vm._v(" "),
              _vm.gameMode == _vm.PythonMode
                ? _c("span", [_vm._v(_vm._s(_vm.$t("Python")))])
                : _vm._e(),
              _vm._v(" "),
              _vm.gameMode == _vm.CppMode
                ? _c("span", [_vm._v(_vm._s(_vm.$t("C++")))])
                : _vm._e(),
              _vm._v(" "),
              _vm.gameMode == _vm.CppOldMode
                ? _c("span", [_vm._v(_vm._s(_vm.$t("CppOldMode")))])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "ul",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.modeSwitchBox,
                      expression: "modeSwitchBox"
                    }
                  ],
                  staticClass: "chooseLangUl"
                },
                [
                  _vm.gameMode != _vm.BlocklyMode
                    ? _c(
                        "li",
                        {
                          on: {
                            click: function($event) {
                              _vm.switchMode(_vm.BlocklyMode)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("index_txtSwitchToBlocky")))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.gameMode != _vm.PythonMode
                    ? _c(
                        "li",
                        {
                          on: {
                            click: function($event) {
                              _vm.switchMode(_vm.PythonMode)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "  " + _vm._s(_vm.$t("index_txtSwitchToPython"))
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.gameMode != _vm.CppMode
                    ? _c(
                        "li",
                        {
                          on: {
                            click: function($event) {
                              _vm.switchMode(_vm.CppMode)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "    " +
                              _vm._s(_vm.$t("index_txtSwitchToCpp")) +
                              "   "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.gameMode != _vm.CppOldMode
                    ? _c(
                        "li",
                        {
                          on: {
                            click: function($event) {
                              _vm.switchMode(_vm.CppOldMode)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "    " +
                              _vm._s(_vm.$t("SwitchToCppOldMode")) +
                              "   "
                          )
                        ]
                      )
                    : _vm._e()
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "settingBtn",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  _vm.setting()
                }
              }
            },
            [
              _c("img", {
                staticClass: "naviIcon",
                attrs: { src: require("@/assets/images/setting.png") }
              }),
              _vm._v(" "),
              _c("span", [
                _vm._v(_vm._s(_vm.userInfo.userName) + " \n            ")
              ]),
              _vm._v(" "),
              _c(
                "ul",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.settingBoxVis,
                      expression: "settingBoxVis"
                    }
                  ],
                  staticClass: "chooseLangUl settingBtn-select"
                },
                [
                  _c("li", { on: { click: _vm.toRace } }, [
                    _vm._v(_vm._s(_vm.$t("myPageTitle")))
                  ]),
                  _vm._v(" "),
                  _c("li", { on: { click: _vm.toMyAccount } }, [
                    _vm._v(_vm._s(_vm.$t("setting_1")))
                  ]),
                  _vm._v(" "),
                  _vm.classShow && _vm.userType === 2
                    ? _c(
                        "li",
                        [
                          _c(
                            "router-link",
                            {
                              staticStyle: { "text-decoration": "none" },
                              attrs: { to: "/star" }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.$t("star_txt7")) +
                                  "\n              "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.classShow &&
                  _vm.userType === 1 &&
                  _vm.$i18n.locale == "zh"
                    ? _c(
                        "li",
                        [
                          _c(
                            "router-link",
                            {
                              staticStyle: { "text-decoration": "none" },
                              attrs: { to: "/star" }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.$t("star_txt8")) +
                                  "\n              "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$i18n.locale == "zh"
                    ? _c("li", [
                        _c(
                          "a",
                          {
                            staticStyle: { "text-decoration": "none" },
                            attrs: {
                              href:
                                _vm.$i18n.locale == "zh"
                                  ? _vm.url.design
                                  : _vm.url.design_en,
                              target: "_blank"
                            }
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.$t("index_txt48")) +
                                "\n              "
                            )
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("li", { on: { click: _vm.toCourseDes } }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("course_explain")) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", { on: { click: _vm.logOut } }, [
                    _vm._v(_vm._s(_vm.$t("setting_2")))
                  ])
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.tipShow,
                  expression: "!tipShow"
                }
              ],
              staticClass: "dialog_9_div"
            },
            [
              _c("div", { staticClass: "blockly" }, [
                _vm.gameMode == _vm.BlocklyMode && _vm.$i18n.locale == "zh"
                  ? _c("img", {
                      attrs: {
                        src: require("@/assets/images/dialog_9_1.png"),
                        width: "200px"
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.gameMode == _vm.PythonMode && _vm.$i18n.locale != "zh"
                  ? _c("img", {
                      attrs: {
                        src: require("@/assets/images/dialog_9_1_EN.png"),
                        width: "200px"
                      }
                    })
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "btn" }, [
                _c("img", {
                  attrs: {
                    src: require("@/assets/images/dialog_9_ok_EN.png"),
                    id: "dialog_9_ok",
                    width: "100px"
                  },
                  on: {
                    click: function($event) {
                      _vm.closeDialogs(2)
                    }
                  }
                })
              ])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mainBoxWrapper", on: { click: _vm.clickBox } },
        [
          _c("div", { staticClass: "mainBox", attrs: { id: "mainBox" } }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.gameMode < 3,
                    expression: "gameMode < 3"
                  }
                ]
              },
              [
                _c("div", { staticClass: "upper-conBox clearfix" }, [
                  _c(
                    "div",
                    { staticClass: "tableBox", class: _vm.getFrame() },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "logo",
                          class: {
                            vip: _vm.vipLogo
                          }
                        },
                        [
                          _c("img", {
                            staticClass: "avatorImg",
                            attrs: {
                              src: _vm.userAvator.url,
                              width: "126",
                              height: "126"
                            },
                            on: { click: _vm.toMyAccount }
                          }),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass: "titlesVip",
                              class: { courseTitleVip: _vm.userInfo.isVip == 1 }
                            },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm.vipTextFilter(_vm.userInfo.isVip)
                                  ) +
                                  "\n                "
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "icode icodeName" }, [
                        _vm._v(_vm._s(_vm.userInfo.userName))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "icode icodeGrade" }, [
                        _vm._v(_vm._s(_vm.gradeFilter(_vm.userInfo.grade)))
                      ]),
                      _vm._v(" "),
                      _vm.gameMode == _vm.BlocklyMode
                        ? _c("div", { staticClass: "icode icodeLevel" }, [
                            _vm._v(
                              _vm._s(
                                _vm.levelFilter(
                                  _vm.gameMode,
                                  _vm.userInfo.blockyLevel
                                )
                              )
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.gameMode == _vm.PythonMode
                        ? _c("div", { staticClass: "icode icodeLevel" }, [
                            _vm._v(
                              _vm._s(
                                _vm.levelFilter(
                                  _vm.gameMode,
                                  _vm.userInfo.pythonLevel
                                )
                              )
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.gameMode == _vm.CppMode
                        ? _c("div", { staticClass: "icode icodeLevel" }, [
                            _vm._v(
                              _vm._s(
                                _vm.levelFilter(
                                  _vm.gameMode,
                                  _vm.userInfo.cppLevel
                                )
                              )
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.userInfo.isVip == 0
                        ? _c(
                            "div",
                            {
                              staticClass: "vipIcode",
                              class: { isEventBoard: _vm.isEventJoined },
                              on: { click: _vm.becomeVip }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.vipTipsFilter(_vm.userInfo.isVip)
                                  ) +
                                  "\n              "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.userInfo.isVip == 1
                        ? _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: {
                                effect: "light",
                                content: _vm.$t("Expiry time: ") + _vm.vipTime,
                                placement: "top-end"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "vipIcode",
                                  class: { isEventBoard: _vm.isEventJoined },
                                  on: { click: _vm.becomeVip }
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.vipTipsFilter(_vm.userInfo.isVip)
                                      ) +
                                      "\n                "
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "myInfoBox" }, [
                    _c("div", { staticClass: "gameImgEn" }, [
                      _c(
                        "div",
                        { staticClass: "block" },
                        [
                          _c(
                            "el-carousel",
                            {
                              attrs: {
                                trigger: "click",
                                height: "160px",
                                interval: 1000000
                              }
                            },
                            [
                              _c("el-carousel-item", [
                                _vm.$i18n.locale != "he"
                                  ? _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t("notice_lang1")
                                        )
                                      }
                                    })
                                  : _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(_vm.$t("notice_isr1"))
                                      }
                                    })
                              ]),
                              _vm._v(" "),
                              _c("el-carousel-item", [
                                _vm.$i18n.locale != "he"
                                  ? _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t("notice_lang2")
                                        )
                                      }
                                    })
                                  : _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(_vm.$t("notice_isr2"))
                                      }
                                    })
                              ]),
                              _vm._v(" "),
                              _c("el-carousel-item", [
                                _vm.$i18n.locale != "he"
                                  ? _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t("notice_lang3")
                                        )
                                      }
                                    })
                                  : _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(_vm.$t("notice_isr3"))
                                      }
                                    })
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "lower-conBox clearfix" }, [
                  _c("div", { staticClass: "leftIcode" }, [
                    _c("span", { staticClass: "icodeTit" }, [
                      _vm._v(_vm._s(_vm.$t("index_txt15")))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "arrows" }, [
                      _c("span", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.preShow,
                            expression: "preShow"
                          }
                        ],
                        staticClass: "pre",
                        on: { click: _vm.pre }
                      }),
                      _vm._v(" "),
                      _c("span", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.nextShow,
                            expression: "nextShow"
                          }
                        ],
                        staticClass: "next",
                        on: { click: _vm.next }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "planets" }, [
                      _c(
                        "ul",
                        { staticClass: "planet" },
                        _vm._l(_vm.planetList, function(item, index) {
                          return _c(
                            "li",
                            {
                              key: index,
                              staticClass: "planetLis",
                              class: { planetLisBg: item.locked },
                              on: {
                                click: function($event) {
                                  _vm.checkLi(item, index)
                                }
                              }
                            },
                            [
                              _c("div", { staticClass: "lisBgs" }),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "planetLiss",
                                class: "planetLis" + (index + 1)
                              }),
                              _vm._v(" "),
                              item.locked
                                ? _c(
                                    "el-tooltip",
                                    {
                                      staticClass: "item",
                                      attrs: {
                                        effect: "light",
                                        content: _vm.$t(
                                          "Require level {level} pass to unlock.",
                                          {
                                            level: _vm.gameLevelFilter(item.id)
                                          }
                                        ),
                                        placement: "top-end"
                                      }
                                    },
                                    [_c("i", { staticClass: "bgIcon" })]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        })
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.courseListShow,
                          expression: "courseListShow"
                        }
                      ],
                      staticClass: "rightIcode",
                      attrs: {
                        "element-loading-spinner": "el-icon-loading",
                        "element-loading-background": "rgba(0, 43, 70, 0.8)"
                      }
                    },
                    [
                      _c("div", { staticClass: "tipsIcode" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "Welcome to Training ground: Level {level}",
                              { level: _vm.gameLevelFilter(_vm.tipsText) }
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _vm.preIcodeShow
                        ? _c("span", {
                            staticClass: "allArrows preIcode",
                            on: { click: _vm.preIcode }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.nextIcodeShow
                        ? _c("span", {
                            staticClass: "allArrows nextIcode",
                            on: { click: _vm.nextIcode }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "course" }, [
                        false
                          ? _c("div", { staticClass: "noCourseTxt" }, [
                              _c("div", [
                                _vm._v(_vm._s(_vm.$t("no_data_course_txt_0")))
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(_vm._s(_vm.$t("no_data_course_txt_1")))
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "ul",
                          { staticClass: "courseUl" },
                          _vm._l(_vm.courseList, function(course, index) {
                            return _c(
                              "li",
                              { key: index, staticClass: "courseLis" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "courseTitle",
                                    class: {
                                      courseTitleVip: course.gameType == 6
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(_vm.courseFilter(course)) +
                                        "\n                    "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("img", {
                                  staticClass: "courseImg",
                                  attrs: {
                                    src: _vm.getCourseICon(
                                      course.gameId,
                                      course.gameType
                                    )
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "courseScorce" }, [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(course.userScore) +
                                      "/" +
                                      _vm._s(course.totalScore) +
                                      "\n                    "
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "courseStart",
                                    on: {
                                      click: function($event) {
                                        _vm.startLearn(course)
                                      }
                                    }
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("index_txt20")))
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                course.locked
                                  ? _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "course",
                                        attrs: {
                                          effect: "light",
                                          content: _vm.$t("index_txt37"),
                                          placement: "top-end"
                                        }
                                      },
                                      [_c("i", { staticClass: "bgIcon" })]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          })
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "learnMsg" }, [
                        _vm.progress_max != 0
                          ? _c(
                              "div",
                              { staticClass: "progressBar" },
                              [
                                _c("el-progress", {
                                  attrs: {
                                    percentage: _vm.progress_length,
                                    color: "#33d3dd"
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "progressStarMain" }, [
                                  _c(
                                    "i",
                                    {
                                      staticClass: "progressStar",
                                      style: _vm.barStyle,
                                      on: {
                                        mouseover: function($event) {
                                          _vm.progressStarHover = true
                                        },
                                        mouseout: function($event) {
                                          _vm.progressStarHover = false
                                        }
                                      }
                                    },
                                    [
                                      _c("section", {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              _vm.progressStarHover === true,
                                            expression:
                                              "progressStarHover === true"
                                          }
                                        ],
                                        staticClass: "progressMsg",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$t("course_unlocktxt1") +
                                              " " +
                                              _vm.progressStar_lockPoint +
                                              " " +
                                              _vm.$t("course_unlocktxt2")
                                          )
                                        }
                                      })
                                    ]
                                  )
                                ])
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("span", { staticClass: "progress_txt" }, [
                          _vm._v(
                            "\n                  " +
                              _vm._s(_vm.progress_current) +
                              "/" +
                              _vm._s(_vm.progress_max) +
                              "\n                "
                          )
                        ]),
                        _vm._v(" "),
                        _vm.ysList.length != 0 && _vm.$i18n.locale != "he"
                          ? _c("div", { staticClass: "raceGoBtn" }, [
                              _c("span", { on: { click: _vm.raceGo } }, [
                                _vm._v(_vm._s(_vm.$t("raceGo")))
                              ])
                            ])
                          : _vm._e()
                      ])
                    ]
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _vm.gameMode == _vm.CppOldMode
              ? _c("div", { staticClass: "Cpp" }, [
                  _c("div", { staticClass: "CppContent" }, [
                    _c("div", { staticClass: "CppMaterial" }, [
                      _c("img", {
                        attrs: { src: _vm.userAvator.url, alt: "" }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "CppUserInfo" }, [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "max-width": "200px",
                              width: "100%",
                              overflow: "hidden",
                              "text-overflow": "ellipsis",
                              "white-space": "nowrap"
                            }
                          },
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.userInfo.userName) +
                                "\n                "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(_vm._s(_vm.gradeFilter(_vm.userInfo.grade)))
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "CppBulletin" }, [
                      _c("p", { staticClass: "bulletTitle" }, [
                        _vm._v(_vm._s(_vm.$t("index_cpp")))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "bulletContent" }, [
                        _c("p", [_vm._v(_vm._s(_vm.$t("index_icode_cpp")))])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "courseList" }, [
                    _c(
                      "p",
                      {
                        staticStyle: {
                          width: "775px",
                          "font-size": "36px",
                          "font-weight": "bold",
                          "text-align": "center"
                        }
                      },
                      [_vm._v("课程列表")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "pack" },
                      [
                        _vm._l(_vm.arr, function(item, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              ref: "courseItem",
                              refInFor: true,
                              staticClass: "courseItem",
                              on: {
                                mouseout: function($event) {
                                  _vm.mouseoutBox(index)
                                },
                                mouseover: function($event) {
                                  _vm.mouseoverBox(index)
                                }
                              }
                            },
                            [
                              _c("div", { staticClass: "courseItems" }, [
                                item.status == 1
                                  ? _c("img", {
                                      staticStyle: {
                                        "border-top-left-radius": "10px",
                                        "border-top-right-radius": "10px"
                                      },
                                      attrs: {
                                        src:
                                          _vm.vip == 0
                                            ? item.notVipUrl
                                            : item.vipUrl,
                                        alt: ""
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.vipToCpp(
                                            item.cGameId,
                                            item.status
                                          )
                                        }
                                      }
                                    })
                                  : _c("img", {
                                      staticStyle: {
                                        "border-top-left-radius": "10px",
                                        "border-top-right-radius": "10px"
                                      },
                                      attrs: { src: item.notOpenUrl, alt: "" },
                                      on: {
                                        click: function($event) {
                                          _vm.vipToCpp(
                                            item.cGameId,
                                            item.status
                                          )
                                        }
                                      }
                                    }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "introduce" },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticStyle: {
                                          "font-size": "10px",
                                          color: "#595757",
                                          height: "49px",
                                          padding: "0 10px",
                                          "text-indent": "15px"
                                        }
                                      },
                                      [_vm._v(_vm._s(item.introduce))]
                                    ),
                                    _vm._v(" "),
                                    Math.floor(
                                      (item.successTaskCount /
                                        item.totalTaskCount) *
                                        100
                                    ) != 0 && item.status != 0
                                      ? _c("el-progress", {
                                          staticStyle: {
                                            width: "340px",
                                            margin: "-10px auto"
                                          },
                                          attrs: {
                                            color: _vm.customColor,
                                            "text-inside": true,
                                            "stroke-width": 15,
                                            percentage: Math.floor(
                                              (item.successTaskCount /
                                                item.totalTaskCount) *
                                                100
                                            )
                                              ? Math.floor(
                                                  (item.successTaskCount /
                                                    item.totalTaskCount) *
                                                    100
                                                )
                                              : 0
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ])
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "runDialog" },
                          [
                            _c(
                              "el-dialog",
                              {
                                attrs: {
                                  title: "",
                                  visible: _vm.runCenterDialogVisible,
                                  center: ""
                                },
                                on: {
                                  "update:visible": function($event) {
                                    _vm.runCenterDialogVisible = $event
                                  }
                                }
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("../assets/cancle.png"),
                                    alt: ""
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.runCenterDialogVisible = false
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "text" }, [
                                  _vm._v("成为正式宇航员即可开启")
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "dialog-footer",
                                    attrs: { slot: "footer" },
                                    slot: "footer"
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "primary" },
                                        on: { click: _vm.newOpen }
                                      },
                                      [_vm._v("立即开通")]
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "noOpen" },
                          [
                            _c(
                              "el-dialog",
                              {
                                attrs: {
                                  title: "",
                                  visible: _vm.centerDialogVisible,
                                  center: ""
                                },
                                on: {
                                  "update:visible": function($event) {
                                    _vm.centerDialogVisible = $event
                                  }
                                }
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("../assets/cancle.png"),
                                    alt: ""
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.centerDialogVisible = false
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "text" }, [
                                  _vm._v("该课程暂未开放")
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "dialog-footer",
                                    attrs: { slot: "footer" },
                                    slot: "footer"
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "primary" },
                                        on: {
                                          click: function($event) {
                                            _vm.centerDialogVisible = false
                                          }
                                        }
                                      },
                                      [_vm._v("返回")]
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "CppFooter" },
                      [
                        _c("el-pagination", {
                          attrs: {
                            layout: "prev, pager, next",
                            "page-size": _vm.pagesize,
                            total: _vm.total,
                            background: true
                          },
                          on: {
                            "current-change": _vm.handleCurrentChange,
                            "next-click": _vm.nextClick,
                            "prev-click": _vm.prevClick
                          }
                        })
                      ],
                      1
                    )
                  ])
                ])
              : _vm._e()
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "chooseMode",
          attrs: {
            visible: _vm.if_Freshman_Visible,
            "close-on-click-modal": false,
            "show-close": false,
            width: "900px",
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.if_Freshman_Visible = $event
            }
          }
        },
        [
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "title" }, [
              _c("h2", [
                _vm._v(_vm._s(_vm.$t("Please select a programming mode")))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "tip" }, [
              _c("b", [_vm._v(_vm._s(_vm.$t("The robot Dev is in trouble")))])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "btn" }, [
              _c("section", [
                _c("div", {
                  staticClass: "btn-blocky",
                  on: {
                    click: function($event) {
                      _vm.handleMode(0)
                    }
                  }
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass: "btn-python",
                  on: {
                    click: function($event) {
                      _vm.handleMode(1)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("section", { staticClass: "btn_text" }, [
                _c("div", { staticClass: "btn-blocky__text" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("freshMan_blocky_text")) +
                      "\n            "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "btn-python__text" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("freshMan_python_text")) +
                      "\n            "
                  )
                ])
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "chooseMode",
          attrs: {
            visible: _vm.if_Instruction_Visible,
            "close-on-click-modal": false,
            "show-close": false,
            width: "900px",
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.if_Instruction_Visible = $event
            }
          }
        },
        [
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "title" }, [
              _c("h2", [
                _vm._v(
                  _vm._s(
                    _vm.$t("Would you like to watch the instruction video?")
                  )
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "tip" }, [
              _c("b", [
                _vm._v(
                  _vm._s(_vm.$t("using the ICode platform for the first time"))
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "btn" }, [
              _c(
                "div",
                {
                  staticClass: "btn-closeInstruction",
                  on: {
                    click: function($event) {
                      _vm.closeInstructionVideo()
                    }
                  }
                },
                [
                  _c("span", [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("Skip")) +
                        "\n            "
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "btn-playInstruction",
                  on: {
                    click: function($event) {
                      _vm.playInstructionVideo()
                    }
                  }
                },
                [
                  _c("span", [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("Play")) +
                        "\n            "
                    )
                  ])
                ]
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "unlockTrain",
          attrs: {
            visible: _vm.if_unlockTrain_Visible,
            "close-on-click-modal": false,
            "show-close": false,
            width: "600px",
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.if_unlockTrain_Visible = $event
            }
          }
        },
        [
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "title" }, [
              _c("h2", [_vm._v(_vm._s(_vm.$t("unlocked a new level")))])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "tip" }, [
              _c("span", [
                _vm._v(_vm._s(_vm.$t("Go explore more new knowledge!")))
              ])
            ]),
            _vm._v(" "),
            _c("i", {
              staticClass: "closeBtn",
              on: {
                click: function($event) {
                  _vm.if_unlockTrain_Visible = false
                }
              }
            })
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.if_IE_hint_Visible, width: "600px" },
          on: {
            "update:visible": function($event) {
              _vm.if_IE_hint_Visible = $event
            }
          }
        },
        [
          _c("span", [_vm._v(_vm._s(_vm.$t("broswer1")))]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer", align: "center" },
              slot: "footer"
            },
            [
              _c(
                "a",
                { attrs: { target: "_blank", href: _vm.url.chromeWin } },
                [_vm._v(_vm._s(_vm.$t("broswer2")))]
              ),
              _vm._v("\n          \n        "),
              _c(
                "a",
                { attrs: { target: "_blank", href: _vm.url.chromeWin64 } },
                [_vm._v(_vm._s(_vm.$t("broswer3")))]
              ),
              _vm._v("\n          \n        "),
              _c("a", { attrs: { target: "_blank", href: _vm.url.macWin } }, [
                _vm._v(_vm._s(_vm.$t("broswer4")))
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _vm.PreVideoShow
        ? _c("div", { staticClass: "videoWrapper" }, [
            _c("video", {
              attrs: {
                src:
                  _vm.staticDomain +
                  "assets/game/static/video/" +
                  _vm.$i18n.locale +
                  "/video01.mp4",
                autoplay: ""
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "btn" }, [
              _c("img", {
                attrs: {
                  src: require("@/assets/images/unlockbtn.png"),
                  width: "40px"
                },
                on: {
                  click: function($event) {
                    _vm.closeDialogs(1)
                  }
                }
              })
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.maskBox
        ? _c("LeapPopup", {
            attrs: {
              title: _vm.$t("timeout01"),
              content: _vm.$t("timeout02"),
              cancelButtonTxt: _vm.$t("timeout04"),
              okButtonTxt: _vm.$t("timeout03"),
              isConfirm: false
            },
            on: { onOK: _vm.logOut }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.final2024popup
        ? _c("LeapPopup", {
            attrs: {
              title: "恭喜你",
              content:
                "恭喜您，您已经获得2024年中国区决赛资格，点击确认前往报名参赛。中国区决赛将于7月13-14日在全国15个城市举办，您可以选择你最喜欢的地点前往。",
              cancelButtonTxt: _vm.$t("timeout04"),
              okButtonTxt: _vm.$t("timeout03"),
              isConfirm: true
            },
            on: {
              onConfirm: _vm.go2024,
              onCancel: function($event) {
                _vm.final2024popup = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "python" }, [
      _c("img", { attrs: { id: "dialog_9_2", width: "200px" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47323bf2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47323bf2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index.vue
// module id = null
// module chunks = 